// Use this import if you want to use "env.js" file
// const { API_URL } = require("../../config/env")
// Or just specify it directly like this:

import { logger } from '../utils/logger';

const API_URL = process.env.REACT_APP_BASE_URL || '';
const UCO_URL = process.env.REACT_APP_UCO_URL || '';

const log = logger().child({ module: 'ApiConfig' });

/**
 * The options used to configure the API.
 */
export interface ApiConfig {
  /**
   * The URL of the api.
   */
  url: string;

  /**
   * Milliseconds before we timeout the request.
   */
  timeout: number;
}

/**
 * The default configuration for the app.
 */
export const DEFAULT_API_CONFIG: ApiConfig = {
  url: API_URL,
  timeout: 10000,
};

export const UCO_API_CONFIG: ApiConfig = {
  url: UCO_URL,
  timeout: 10000,
};
